var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCalendar = function SvgCalendar(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2,0,0,2,0,0)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:currentColor;stroke-linecap: round;stroke-linejoin: round;stroke-width: 2px;}")), /*#__PURE__*/React.createElement("title", null, "calendar-3"), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 0.75,
    y: 3.75,
    width: 22.5,
    height: 19.5,
    rx: 1.5,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 0.75,
    y1: 9.75,
    x2: 23.25,
    y2: 9.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 6.75,
    y1: 6,
    x2: 6.75,
    y2: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 17.25,
    y1: 6,
    x2: 17.25,
    y2: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 5.625,
    y1: 13.5,
    x2: 5.625,
    y2: 13.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.625,13.5A.375.375,0,1,0,6,13.875a.375.375,0,0,0-.375-.375"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 5.625,
    y1: 18.75,
    x2: 5.625,
    y2: 18.75
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.625,18.75A.375.375,0,1,0,6,19.125a.375.375,0,0,0-.375-.375"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 12,
    y1: 13.5,
    x2: 12,
    y2: 13.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12,13.5a.375.375,0,1,0,.375.375A.375.375,0,0,0,12,13.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 12,
    y1: 18.75,
    x2: 12,
    y2: 18.75
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12,18.75a.375.375,0,1,0,.375.375A.375.375,0,0,0,12,18.75"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 18.375,
    y1: 13.5,
    x2: 18.375,
    y2: 13.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18.375,13.5a.375.375,0,1,0,.375.375.375.375,0,0,0-.375-.375"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 18.375,
    y1: 18.75,
    x2: 18.375,
    y2: 18.75
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18.375,18.75a.375.375,0,1,0,.375.375.375.375,0,0,0-.375-.375"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCalendar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "calendar.2e52027e7410a4cac0b1ac50197e8ff1.svg";